import { Link } from 'react-router-dom'
import { reopenConsentBanner } from '@/lib/cookie-consent'

export function SiteFooter() {
  return (
    <footer className="border-t border-n-200 bg-n-100 px-4 pb-14 pt-16 min-[900px]:px-8 min-[900px]:pt-24">
      <div className="mx-auto max-w-[1400px]">
        <p className="max-w-[16ch] font-display text-[clamp(40px,9vw,88px)] italic leading-[0.98] tracking-[-0.01em] text-ink">
          Let's run something.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-x-10 gap-y-3 border-t border-n-200 pt-8 text-body">
          <a
            href="mailto:FlowScale1@outlook.com"
            className="flex min-h-11 items-center text-ink underline decoration-n-200 underline-offset-4 hover:text-flow hover:decoration-flow"
          >
            FlowScale1@outlook.com
          </a>
          <a
            href="tel:+19568871317"
            className="flex min-h-11 items-center text-ink tabular-nums underline decoration-n-200 underline-offset-4 hover:text-flow hover:decoration-flow"
          >
            (956) 887-1317
          </a>
          <Link to="/faq" className="flex min-h-11 items-center text-n-500 hover:text-ink">
            FAQ
          </Link>
          <Link to="/privacy-policy" className="flex min-h-11 items-center text-n-500 hover:text-ink">
            Privacy
          </Link>
          <Link to="/terms-of-service" className="flex min-h-11 items-center text-n-500 hover:text-ink">
            Terms
          </Link>
          <button
            type="button"
            onClick={() => reopenConsentBanner()}
            className="flex min-h-11 items-center text-n-500 hover:text-ink"
          >
            Cookie preferences
          </button>
          <span className="ml-auto flex min-h-11 items-center pr-0 text-meta text-n-500 min-[900px]:pr-20">
            Flowscale &middot; Edinburg, TX
          </span>
        </div>
      </div>
    </footer>
  )
}
